import BookIcon from '@mui/icons-material/Book';
import RanCreate from './RanCreate';
import RanEdit from './RanEdit';
import RanList from './RanList';
import RanShow from './RanShow';

export default {
    list: RanList,
    create: RanCreate,
    edit: RanEdit,
    show: RanShow,
    icon: BookIcon,
};
